import { statusCodeToMessage } from '@/utils/errors';

export function getCategoryErrorMessage(error, operation, entityType = 'category') {
  const statusCode = error?.status || error?.data?.status || 'FETCH_ERROR';
  const entityName = entityType === 'subcategory' ? 'Subcategory' : 'Category';
  
  if (statusCode === 409) {
    if (operation === 'delete') {
      return `Cannot delete ${entityName} because it contains ingredients.`;
    } else {
      return `${entityName} with this name already exists.`;
    }
  }
  
  return statusCodeToMessage(statusCode);
}
